import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: 'unaudited',
    detailDialogVisible: false,
    auditDetail: {}
  },
  getters: {},
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload;
    }
  },
  actions: {
    list({ commit }, query) { // eslint-disable-line
      api.getAuditList(query).then(({ data }) => {
        if(data=='没有数据'){
          commit('setAuditList',[])
        }else{
          commit('setAuditList', data);
        }
        
      });
    },
    RemoveLog(context, data) {
     return api.RemoveLog(data);
    }
  }
};

appStore.registerModule('logLim', store);
